import Form from "views/Form";
import className from "classnames";
import { toast } from "react-hot-toast";
import { parseError } from "utils/helpers";
import { searchHandler } from "models/search";
import { dropdownItemSelector } from "models/form";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useLayoutEffect, useState } from "react";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { selectAllResults } from "features/search/searchSlice";
import FormElement from "components/Form/FormElement/FormElement";
import { createSearchParams, useNavigate } from "react-router-dom";
import FormDropdown from "components/Form/FormDropdown/FormDropdown";
import { formConfig } from "pages/CallCenter/CallCenterQueues/NewCenterQueue/formConfig";
import { useCreateCallCenterQueuesMutation } from "features/call_center/callCenterApiSlice";

import cardStyles from "styles/modules/Card.module.scss";
import formStyles from "components/Form/Form.module.scss";
import utilityStyles from "styles/modules/Utility.module.scss";

const form = new Form(formConfig);

const NewCenterQueue = () => {
  const [formElements, setFormElements] = useState([]);
  const [formValidity, setFormValidity] = useState(false);
  const [activeInput, setActiveInput] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const searchResults = useSelector(selectAllResults);
  const [createQueue, { isLoading }] = useCreateCallCenterQueuesMutation();

  useEffect(() => {
    dispatch(setNavbarTitle("New Call Center Queue"));
  }, [dispatch]);

  useLayoutEffect(() => {
    form.createFormElements();
    setFormElements(form.formElements);
  }, []);

  useEffect(() => {
    return () => {
      if (process.env.NODE_ENV === "production") {
        form.clear();
        form.setConfig(formConfig);
      }
    };
  }, []);

  const submitFormHandler = async (e) => {
    e.preventDefault();

    if (!formValidity) return;

    const data = {};
    const parameters = {};

    const config = form.getFormConfig();

    for (const key in config) {
      const el = config[key];
      const value =
        key.split("_")[1] === "id" ? el.elementConfig["data-id"] : el.elementConfig.value;

      if (key.startsWith("parameters.")) {
        parameters[key.split(".")[1]] = value;
      } else {
        data[key] = value;
      }
    }

    data.parameters = parameters;

    try {
      await createQueue(data).unwrap();
      toast.success("Queue created successfully");
      navigate({
        pathname: "/call_center/queues",
        search: createSearchParams({ page: "1" }).toString(),
      });
      setTimeout(() => {
        window.location.reload();
      }, (3000))
    } catch (err) {
      toast.error(parseError(err));
    }
  };

  const dropdownItemClickHandler = (key, item) => {
    dropdownItemSelector(key, item, form);
    setFormElements(form.formElements);
    setActiveInput("");
  };

  const inputChangeHandler = (e) => {
    const updatedInput = form.inputChangeHandler(e);

    setActiveInput(e.target.id);

    if (updatedInput) {
      if (e.target.id === "domain_id") {
        searchHandler("/domains", e.target.value, dispatch);
      }

      form.updateFormElement({ id: e.target.id, config: updatedInput });
      form.checkFormValidity();
      setFormElements(form.formElements);
      setFormValidity(form.isValid);
    }
  };

  return (
    <div className={`${utilityStyles.flexColumn} ${utilityStyles.itemsCenter} ${utilityStyles.justifyCenter}`}>
      <div className={className({ [cardStyles.menu]: true, [utilityStyles.wFull]: true })}>
        <h3>Create a New Call Center Queue</h3>
      </div>
      <div className={formStyles.wrapper}>
        <form className={formStyles.container} onSubmit={submitFormHandler}>
          {formElements.map((el, idx) => {
            const { title, elementType, elementConfig, ...config } = el.config;
            return (
              <div key={`el-group-${idx + 1}`} className={formStyles.group}>
                <FormElement
                  {...config}
                  title={title}
                  type={elementType}
                  id={elementConfig.id}
                  config={{
                    ...elementConfig,
                    onChange: inputChangeHandler,
                  }}
                />
                <FormDropdown
                  items={searchResults}
                  itemClickHandler={(item) =>
                    dropdownItemClickHandler(elementConfig.id, item)
                  }
                  visible={
                    activeInput === elementConfig.id && el.config.dropdown
                  }
                />
              </div>
            );
          })}
          <div className={formStyles.btn}>
            <button disabled={!formValidity || isLoading}>
              {isLoading ? "Creating Queue..." : "Create Queue"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewCenterQueue;
